import { render, staticRenderFns } from "./OptionGroupGeneral.vue?vue&type=template&id=38a70e59&scoped=true&"
import script from "./OptionGroupGeneral.vue?vue&type=script&lang=js&"
export * from "./OptionGroupGeneral.vue?vue&type=script&lang=js&"
import style0 from "./OptionGroupGeneral.vue?vue&type=style&index=0&id=38a70e59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a70e59",
  null
  
)

export default component.exports